module.exports = __webpack_public_path__ + "static/key-xmorph-d806041a802209c158bdabfe7f591f5c.webp";